import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonDetailCard = _resolveComponent("PersonDetailCard")!
  const _component_FaceDetailDialog = _resolveComponent("FaceDetailDialog")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    maximized: "",
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hide')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PersonDetailCard, {
        ref: "card",
        "client-id": _ctx.clientId,
        onClose: _ctx.close,
        onFaceClick: _ctx.openFace,
        onUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updated', $event)))
      }, null, 8, ["client-id", "onClose", "onFaceClick"]),
      _createVNode(_component_FaceDetailDialog, {
        ref: "faceDetail",
        "show-view-person": false
      }, null, 512)
    ]),
    _: 1
  }, 512))
}